// eslint-disable-next-line
// @ts-nocheck
import { i18n } from '@/lang/i18n';
import { pinia } from '@/store';
import { useCommonStore } from '@/store/common';

const { t } = i18n.global;
const commonStore = useCommonStore(pinia);

// 交易路由 7个
const trade = [
  {
    path: '/spot/:symbolPath',
    component: () => import('@/pages/spot/Index.vue'),
    meta: {
      layout: 'exchange',
      theme: true,
      title: t('tdk_trade_meta_title'),
      description: t('tdk_trade_meta_description'),
      keywords: t('tdk_trade_meta_keywords'),
      props: { header: { border: false } },
      ssg: {}
    }
  },
  {
    path: '/spot',
    component: () => import('@/pages/spot/Index.vue'),
    meta: {
      layout: 'exchange',
      theme: true,
      title: t('tdk_trade_meta_title'),
      description: t('tdk_trade_meta_description'),
      keywords: t('tdk_trade_meta_keywords'),
      props: { header: { border: false } },
      ssg: {}
    }
  },
  {
    path: '/order',
    component: () => import('@/pages/order/Index.vue'),
    meta: {
      layout: 'default',
      auth: 'login',
      title: t('tdk_order_meta_title'),
      description: t('tdk_order_meta_description'),
      keywords: t('tdk_order_meta_keywords')
    }
  },
  {
    path: '/transfer/details',
    component: () => import('@/pages/order/TransferDetails.vue'),
    meta: {
      layout: 'default',
      auth: 'login',
      title: t('tdk_transfer_details_meta_title'),
      description: t('tdk_transfer_details_meta_description'),
      keywords: t('tdk_transfer_details_meta_keywords')
      // ssg: {}
    }
  },
  {
    path: '/markets',
    component: () => import('@/pages/markets/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_markets_meta_title'),
      description: t('tdk_markets_meta_description'),
      keywords: t('tdk_markets_meta_keywords'),
      ssg: {
        preload: [commonStore.getSymbols, commonStore.getCurrency]
      }
    }
  },
  {
    path: '/markets/:symbolPath',
    component: () => import('@/pages/price/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_price_meta_title'),
      description: t('tdk_price_meta_description'),
      keywords: t('tdk_price_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/price/:symbolPath',
    redirect: to => {
      return { path: `/markets/${to.params.symbolPath}` };
    }
  },
  {
    path: '/markets/epotter-eth/:symbolPath',
    component: () => import('@/pages/epeth/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_price_meta_title'),
      description: t('tdk_price_meta_description'),
      keywords: t('tdk_price_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/epeth/:symbolPath',
    redirect: to => {
      return { path: `/markets/epotter-eth/${to.params.symbolPath}` };
    }
  },
  {
    path: '/markets/epotter-eth',
    component: () => import('@/pages/epeth/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_epeth_meta_title'),
      description: t('tdk_epeth_meta_description'),
      keywords: t('tdk_epeth_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/epeth',
    redirect: '/markets/epotter-eth'
  },
  {
    path: '/markets/hsk-usd',
    component: () => import('@/pages/hskIndex/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_hskindex_meta_title'),
      description: t('tdk_hskindex_meta_description'),
      keywords: t('tdk_hskindex_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/hskIndex',
    component: () => import('@/pages/hskIndex/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_hskindex_meta_title'),
      description: t('tdk_hskindex_meta_description'),
      keywords: t('tdk_hskindex_meta_keywords'),
      ssg: {}
    },
    redirect: '/markets/hsk-usd'
  }
];

export default trade;
